document.addEventListener('DOMContentLoaded', () => {
    const openPopupButton = document.getElementById('open-popup-size');
    const closePopupButton = document.getElementById('close-popup-size');
    const popupSize = document.getElementById('popup-size');
    const openPopup = () => {
        popupSize.style.display = 'block';
        document.body.classList.add('popup-open');
    };
    const closePopup = () => {
        popupSize.style.display = 'none';
        document.body.classList.remove('popup-open');
    };
    if (openPopupButton) {
        openPopupButton.addEventListener('click', openPopup);
        closePopupButton.addEventListener('click', closePopup);
    }
});